var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSync(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(-624.591 -364.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1185",
    "data-name": "Rectangle 1185",
    width: 20,
    height: 20,
    transform: "translate(624.591 364.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g873",
    transform: "translate(626.885 1049.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g875",
    transform: "translate(0.706 -681.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g883",
    transform: "translate(0.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path885",
    d: "M-580.173-70.9l-4.194,10.905a1.183,1.183,0,0,1-.268.412,1.186,1.186,0,0,1-1.678,0,1.18,1.18,0,0,1-.307-.531l-1.064-3.972a1.181,1.181,0,0,0-.307-.531,1.181,1.181,0,0,0-.531-.307l-3.972-1.064a1.18,1.18,0,0,1-.531-.307,1.186,1.186,0,0,1,0-1.678,1.182,1.182,0,0,1,.412-.268l10.905-4.194a1.187,1.187,0,0,1,1.265.268A1.186,1.186,0,0,1-580.173-70.9Z",
    transform: "translate(593.372 72.511)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g887",
    transform: "translate(0 11.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path889",
    d: "M-110.62,0l-2.517,2.517",
    transform: "translate(113.137)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g891",
    transform: "translate(3.356 12.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path893",
    d: "M-73.746,0l-1.678,1.678",
    transform: "translate(75.424)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g895",
    transform: "translate(0 8.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path897",
    d: "M-73.746,0l-1.678,1.678",
    transform: "translate(75.424)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g899",
    transform: "translate(7.779 3.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path901",
    d: "M-110.62,0l-2.517,2.517",
    transform: "translate(113.137)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSync);
export default __webpack_public_path__ + "static/media/email-sync.80290ffdc8058d2fa044dc95d871fef1.svg";
export { ForwardRef as ReactComponent };